import angular from 'angular';
//import uiRouter from 'angular-ui-router';
import uiMask from 'angular-ui-mask';
import tecobiSmsWidgetComponent from './tecobiSmsWidget.component';
import service from './tecobiSmsWidget.service.js';

const tecobiPowerSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 166.75 142.82">
        <defs><style>.cls-1{fill:#fff;}</style></defs>
        <title>Asset 1</title>
        <g>
            <title>background</title>
            <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/>
        </g>
        <g>
            <title>Layer 1</title>
            <g stroke="null" id="Layer_2">
                <g stroke="null" id="Layer_1-2">
                <path stroke="null" id="svg_1" d="m92.425654,69.404396l-18.093913,0a8.130435,8.130435 0 0 1 -8.130435,-8.130435l0,-42.514783a8.130435,8.130435 0 0 1 8.130435,-8.130435l18.093913,0a8.130435,8.130435 0 0 1 8.130435,8.130435l0,42.514783a8.130435,8.130435 0 0 1 -8.130435,8.130435" class="cls-1"/>
                <path stroke="null" id="svg_2" d="m105.730002,28.523092l0,13.622174a4.434783,4.434783 0 0 0 4.434783,4.434783l0.162609,0a4.434783,4.434783 0 0 1 4.434783,4.434783l0,33.083478a8.130435,8.130435 0 0 1 -8.130435,8.130435l-46.506087,0a8.130435,8.130435 0 0 1 -8.130435,-8.130435l0,-33.083478a4.434783,4.434783 0 0 1 4.434783,-4.434783l0.162609,0a4.434783,4.434783 0 0 0 4.434783,-4.434783l0,-14.361304a5.173913,5.173913 0 0 0 -5.173913,-5.173913l-25.973043,0a8.130435,8.130435 0 0 0 -8.130435,8.130435l0,77.320435a8.130435,8.130435 0 0 0 8.130435,8.130435l106.98913,0a8.130435,8.130435 0 0 0 8.130435,-8.130435l0,-77.320435a8.130435,8.130435 0 0 0 -8.130435,-8.130435l-25.226522,0a5.913043,5.913043 0 0 0 -5.913043,5.913043" class="cls-1"/>
                </g>
            </g>
        </g>
    </svg>`;

const tecobiSmsWidgetModule = angular.module('tecobiSmsWidget', [
  'ngMaterial',
  'ui.mask',
])

// Custom font icon
.run(($templateCache) => {
    'ngInject';
    $templateCache.put('icons/tecobiPower.svg', tecobiPowerSVG);
})

.service('TecobiSmsWidgetService', service)

.component('tecobiSmsWidget', tecobiSmsWidgetComponent)

.name;

export default tecobiSmsWidgetModule;



// WEBPACK FOOTER //
// ./client/app/components/tecobiSmsWidget/tecobiSmsWidget.js